module.exports = __webpack_public_path__ + "img/The_5_questions.b54899f4.png";